import {PageType} from 'modules/decisionsNext/constants/pageType';
import {createEnumMap} from 'utils/createEnumMap';

export enum WhatsNewPeriod {
  All = 'all',
  Today = 'today',
  LastSevenDays = 'lastSevenDays',
  LastThirtyDays = 'lastThirtyDays',
  LastYear = 'lastYear',
}

export const periodMap = [
  {
    value: WhatsNewPeriod.All,
    label: 'All Dates',
  },
  {value: WhatsNewPeriod.Today, label: 'Today'},
  {value: WhatsNewPeriod.LastSevenDays, label: 'Last 7 Days'},
  {value: WhatsNewPeriod.LastThirtyDays, label: 'Last 30 Days'},
  {value: WhatsNewPeriod.LastYear, label: 'Last Year'},
];

export enum FeatureType {
  Light = 'light',
  NewFeature = 'newFeature',
  Update = 'update',
}

export const featureTypesMap = [
  {value: FeatureType.Light, label: 'Light Feature'},
  {value: FeatureType.NewFeature, label: 'New Feature'},
  {value: FeatureType.Update, label: 'Update'},
];

export const categoriesLabelsMap = createEnumMap(
  {
    [PageType.Account]: 'Account',
    [PageType.AccountExecutive]: 'Acc Executive',
    [PageType.AccountExecutives]: 'Acc Executives',
    [PageType.AccountManager]: 'Acc Manager',
    [PageType.AccountManagers]: 'Acc Managers',
    [PageType.Accounts]: 'Accounts',
    [PageType.Activities]: 'Activities',
    [PageType.CarrierAppetite]: 'Carrier Appetite',
    [PageType.Default]: 'Default',
    [PageType.Documents]: 'Documents',
    [PageType.Growth]: 'Growth',
    [PageType.Home]: 'Home',
    [PageType.Industries]: 'Industries',
    [PageType.Industry]: 'Industry',
    [PageType.Intermediaries]: 'Intermediaries',
    [PageType.Intermediary]: 'Intermediary',
    [PageType.Kpi]: 'KPIs',
    [PageType.O360]: 'O360 Score',
    [PageType.LossRuns]: 'Loss Runs',
    [PageType.Market]: 'Market',
    [PageType.Markets]: 'Markets',
    [PageType.MonolineRatios]: 'Monoline Ratios',
    [PageType.RetailClients]: 'Clients',
    [PageType.RetailClient]: 'Client',
    [PageType.Producer]: 'Producer',
    [PageType.Producers]: 'Producers',
    [PageType.Product]: 'Product',
    [PageType.Products]: 'Products',
    [PageType.Prospect]: 'Prospect',
    [PageType.ReportStudio]: 'Report Studio',
    [PageType.Reports]: 'Reports',
    [PageType.Renewals]: 'Renewals',
    [PageType.Retention]: 'Retention',
    [PageType.Unknown]: `Unknown`,
    [PageType.WhatsNew]: `What's New`,
    [PageType.Workflows]: 'Workflows',
    [PageType.DocumentsLibrary]: 'Documents Library',
    [PageType.DocumentsCompare]: 'Documents Compare',
  },
  PageType,
  ''
);

export const SEEN_FEATURES_CUSTOM_SETTING_KEY = 'seenFeaturesTimestamp';
